import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  HOME_CONFIGURATION_GET,
  HOME_COURSE_LIST_GET,
  HOME_LAST_COURSES_GET,
  HOME_NEWS_LIST_GET,
  USEFUL_LINKS_GET,
} from '../actions/home';

const initialState = {
  carouselCategories: [],
  courseList: [],
  news: [],
  usefulLinks: [],
  recentCourses: [],
  menuLogo: {},
  menuLinks: [],
  footer: [],
  subFooter: [],
};

const homeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case HOME_CONFIGURATION_GET._SUCCESS: {
        const { response = {} } = action;
        draft.menuLogo = response?.header?.logo || {};
        draft.menuLinks = [...(response?.header?.menu_items || [])];
        draft.footer = [...(response?.footer?.menu_items || [])];
        draft.subFooter = [...(response?.subfooter?.menu_items || [])];
        break;
      }

      case HOME_COURSE_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.courseList = response;
        break;
      }

      case HOME_NEWS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.news = response;
        break;
      }
      case HOME_LAST_COURSES_GET._SUCCESS: {
        const { response } = action;
        draft.recentCourses = response?.items;
        break;
      }

      case USEFUL_LINKS_GET._SUCCESS: {
        const { response } = action;
        draft.usefulLinks = response;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default homeReducer;
